import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError, Observer } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { OnboardingEnum } from '../../../services/api-names';
import { SessionService } from '../../../services/session.service';
import {
  TECH_LIB_PORTAL_CONFIG,
  TechLibPortalConfig,
} from '../../../tech-lib-portal.interceptor';
import { Utils } from '../../../utils/utils';
import { Serializer } from './../../../helpers/serializer/seriealizer';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  private HttpHeaders: HttpHeaders;

  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private httpBackend: HttpBackend,
    private session: SessionService,
    private http: HttpClient,
    private serializer: Serializer,
    private httpClient: HttpClient,
  ) {}


public getPendingSection() {
  let url = this.config.baseApi + OnboardingEnum.onboarding_pendingsection;
  return this.http.get<any>(url).pipe(
    map((res) => {
      return res;
    }),
    catchError((err) => {
      return throwError(err);
    })
  );
}

public getLegalDocuments(sectionCode: string) {
  const url = Utils.formatString(
    this.config.baseApi + OnboardingEnum.onboarding_legaldocuments,
    [sectionCode]
  );
  return this.http.get<any>(url).pipe(
    map((res) => {
      return res;
    }),
    catchError((err) => {
      return throwError(err);
    })
  );
}

}
